import React, { useEffect } from "react";
import { Banner, Link, Page } from "@shopify/polaris";
import { useRouteError } from "react-router-dom";

export default function InventoryLevelHistoriesErrorPage(): React.ReactElement {
  const error = useRouteError();

  useEffect(() => {
    Rollbar.error(error);
  }, [error]);

  return (
    <Page title="Inventory history">
      <Banner
        action={{ content: "Reload page", onAction: reloadPage }}
        title="Inventory history couldn't load"
        tone="critical"
      >
        Reload the page to try again. If the problem continues,{" "}
        <Link target="_blank" url="mailto:hello@inventory.horse">
          email support
        </Link>
        .
      </Banner>
    </Page>
  );
}

function reloadPage(): void {
  window.location.reload();
}
